{/** Social Media Links */}

export const open = {
    Youtube: () => {
        window.open('https://www.youtube.com/@rekanata.contractors/', '_blank');
    },
    Instagram: () => {
        window.open('https://www.instagram.com/rekanata_konstruksi/', '_blank'); // Ganti dengan username Instagram yang diinginkan
    },
    Twitter: () => {
        window.open('https://x.com/rekanata13', '_blank'); // Ganti dengan username Twitter yang diinginkan
    },
    Facebook: () => {
        window.open('https://www.facebook.com/rekanatacontractors/', '_blank'); // Ganti dengan username Facebook yang diinginkan
    },
    LinkedIn: () => {
        window.open('https://www.linkedin.com/in/rekanatacontractors/', '_blank'); // Ganti dengan username LinkedIn yang diinginkan
    },
    TikTok: () => {
        window.open('https://www.tiktok.com/@rekanata_konstruksi', '_blank'); // Ganti dengan username TikTok yang diinginkan
    }
    /** TikTok: () => {
        window.open('https://www.tiktok.com/@rekanatacontractors/', '_blank'); // Ganti dengan username TikTok yang diinginkan
    } */
};